// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductGroup_container__2zIM-","title":"ProductGroup_title__20xHk"};